import { useState, useEffect } from "react";
import Style from "./BlocksDetailStyle";
import Spinner from "../../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../../shared/Bootstrap/TwoButtonsModal";
import api from "../../../services/api";
import ListApartments from "../../Apartments/ListApartments";

export default function BlocksDetail(props) {

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState({ success: "", error: "" });
  const [apartments, setApartments] = useState([] as any)
  const blockId: number = parseInt(props.match.params.blockId) || 0;
  const enterpriseId = props.match.params.enterpriseId;
  const creatingNew = blockId <= 0;
  useEffect(() => {
    if (!creatingNew) {
      LoadBlock(blockId);
    } else {
      setLoading(false);
    }
  }, []);

  async function LoadBlock(blockId) {
    try {
      setLoading(true);
      const result = await api.get(`/enterprises/${enterpriseId}/blocks/apartments`);
      if (result.data.success) {
        let blocks = result.data.blocks;
        blocks.forEach(block => {
          if (+block.id === +blockId) {
            setId(block.id)
            setName(block.name)
            if (block.apartments.length > 0) {
              setApartments(block.apartments)
            }
          }
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  function OnSubmit() {
    if (creatingNew) {
      onCreate()
    } else {
      onEdit()
    }
  }

  async function onCreate() {
    try {
      setLoading(true);
      const data = {
        blockName: name
      }
      await api.post(`/enterprises/${enterpriseId}/blocks`, data);
      onClosePopup();
      setMessage({ success: `Bloco ${name} criado com sucesso!`, error: "" })
      setLoading(false);
      props.history.goBack();
    }
    catch (error: any) {
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message })
      onClosePopup();
    }
  }
  async function onEdit() {
    try {
      setLoading(true);
      const data = {
        id, blockName: name
      }
      await api.put(`/enterprises/${enterpriseId}/blocks/${blockId}`, data);
      onClosePopup();
      setMessage({ success: `Bloco ${name} editado com sucesso!`, error: "" })
      setLoading(false);
      props.history.goBack()
    }
    catch (error: any) {
      setLoading(false);
      onClosePopup();
      setMessage({ success: "", error: error?.response?.data?.message })
    }
  }
  function onOpenPopUp() {
    setShowPopup(true);
  }

  function onClosePopup() {
    setShowPopup(false);
  }
  loading && <Spinner spinning={loading} />
  return (
    <Style className="default-page">
      <div>
        <TwoButtonsModal
          show={showPopup}
          onHide={onClosePopup}
          loading={loading}
          title={creatingNew ? "Cadastro de bloco" : "Edição de bloco"}
          body={"Você tem certeza que deseja " + (creatingNew ? " Cadastrar este bloco?" : "editar este bloco?")}
          secondaryText="Fechar"
          secondaryOnClick={onClosePopup}
          secondaryDisabled={loading}
          primaryText="Confirmar"
          primaryOnClick={() => OnSubmit()}
          primaryDisabled={loading}
        />
        <div>
          <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
        </div>
        {message.error && <p className="alert alert-error">Erro: {message.error}</p>}
        {message.success && <p className="alert alert-info">{message.success}</p>}
        <main className="default-main">
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault(); }}>
              <h2>{creatingNew ? "Cadastro" : "Edição"} do Bloco</h2>
              <div>
                <label>Nome:</label>
                <input

                  disabled={loading}
                  defaultValue={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>

              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={name === ""}
                onClick={e => {
                  e.preventDefault();
                  onOpenPopUp();
                }}>{creatingNew ? "Cadastrar" : "Editar"}
              </button>
            </form>
          </div>
          {loading ? <Spinner spinning={loading} /> :
            !creatingNew && (
              apartments.length > 0 ? (
                <ListApartments
                  enterpriseId={enterpriseId}
                  blockId={blockId}
                  apartments={apartments}
                  props={props}
                />
              ) : (
                <div>
                  <button
                    className="btn btn-success btn-lg mt-4"
                    type="button"
                    onClick={() => props.history.push(`/enterprises/${enterpriseId}/blocks/${blockId}/create`)}>
                    Gerar apartamentos
                  </button>
                </div>
              )
            )
          }
        </main>
      </div>
    </Style>
  )
}
